import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {DeleteModal, PageLoader, SelectMain, SimpleTabs} from "components";
import {AddNotes, allStatusesList, MainDetails, Notes} from "fragments";
import {Rates, AddRate, Integrations, ApptTimeRules} from "./fragments";
import {payerDetails} from "./constants";
import {FindLoad, useModal, usePrimaryModal} from "utils";
import {payerActions} from "store";
import {Svg} from "assets";

const tabsLabels = [
    {label: "Details"},
    {label: "Rates"},
    {label: "Notes"},
    {label: "Appt Time Rules"},
    {label: "Integrations"},
];

const ACTION_GET_SINGLE = "GET_PAYER_SINGLE";
const ACTION_DELETE = "DELETE_PAYER";

export const PayersSingle = ({item, afterSuccess}) => {
    const {notesList} = useSelector((state) => ({
        notesList: state.notes.notesList,
    }));
    const {control, setValue} = useForm();
    const dispatch = useDispatch();
    const {close} = useModal();
    const {openPrimary, closePrimary} = usePrimaryModal();
    const loading = FindLoad(ACTION_GET_SINGLE)


    useEffect(() => {
        dispatch(payerActions.getPayerSingle(item?.id))
    }, []);

    useEffect(() => {
        if (item?.status) {
            setValue('status', item?.status)
        }
    }, [item?.status]);


    const payerDetailsTabContent = [
        {
            tabComponent: <MainDetails info={payerDetails(item)}/>,
            tab: "Details",
        },

        {
            tabComponent: <Rates payerId={item?.id}/>,
            tab: "Rates",
        },

        {
            tabComponent: <Notes currentId={item?.id} onResource="payer"/>,
            tab: "Notes",
        },

        {
            tabComponent: <ApptTimeRules currentId={item?.id}/>,
            tab: "Appt Time Rules",
        },

        {
            tabComponent: <Integrations currentId={item?.id}/>,
            tab: "Integrations",
        },
    ];

    const changeStatus = (status) => {
        dispatch(payerActions.changeStatus(item?.id, {status}))
    }

    const handleDelete = () => {
        openPrimary(
            <DeleteModal
                handleDelete={() => {
                    dispatch(payerActions.deletePayer(item?.id));
                }}
                handleCancel={closePrimary}
                actionType={ACTION_DELETE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove ${item?.name} ?`}
                afterSuccess={() => {
                    close();
                    closePrimary();
                    afterSuccess()
                }}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 407
            },
        );
    };

    const addRate = (info) => {
        openPrimary(<AddRate info={info} payerId={item?.id}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 482
        });
    };

    const handleAddNote = () => {
        openPrimary(<AddNotes onResource="payer" currentId={item?.id}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 1276
        });
    };

    const handelTextButton = (currentTab) => {
        return (
            (currentTab === "Notes" && notesList?.length && "Add Note") ||
            (currentTab === "Rates" && "Add Rate")
        );
    };

    const handleAdd = (currentNote) => {
        return (
            (currentNote === "Notes" && handleAddNote) ||
            (currentNote === "Rates" && addRate)
        );
    };

    if (!!loading) {
        return <PageLoader
            wrapperHeight="45vh"
            height="100%"
        />
    }

    return (
        <div className="payers-single-wrapper">
            <div className="modal-header-main">
                <h2 className="modal-header-title">{item?.name}</h2>

                <div className="align-center" style={{gap: 8}}>
                    <div style={{minWidth: 145}}>
                        <SelectMain
                            list={allStatusesList}
                            renderLabel={(option) => option.name}
                            name='status'
                            control={control}
                            placeholder="Status"
                            selectedValue={'id'}
                            allowError={false}
                            disableClearable
                            handleChange={changeStatus}
                        />
                    </div>

                    <button className="reset-btn" onClick={handleDelete}>
                        <Svg.TrashSvg/>
                    </button>

                    <button
                        className="modal-close-btn-main"
                        type="button"
                        onClick={close}
                    >
                        <Svg.CloseSvg/>
                    </button>
                </div>
            </div>

            <div className="modal-body-main">
                <SimpleTabs
                    tabsLabels={tabsLabels}
                    tabsContent={payerDetailsTabContent}
                    defaultTab="Details"
                    pushToHistory={false}
                    handelTextButton={handelTextButton}
                    handleAdd={handleAdd}
                />
            </div>
        </div>
    );
};
